import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withStyles } from '@material-ui/core/styles';
import { styles } from "./style";
import "./style.css"
const CustomizedTabs = ({ classes, view, setView, data }) => {
  const [tab, setTab] = React.useState(view)

  const handleChangeTab = (a, index) => {
    setTab(index)
    setView(index)
  }


  return (
    <div id="hyly-tab">
      <Tabs value={tab} onChange={handleChangeTab} aria-label="wrapped label tabs example">
        <Tab
          label={data[1].title}
          value={1}
          className={tab === 1 ? classes.font : classes.tabTitle}
        />
        <Tab value={2} label={data[2].title} className={tab === 2 ? classes.font : classes.tabTitle} />
      </Tabs>
    </div>
  );
}

export default withStyles(styles)(CustomizedTabs);